import { render, staticRenderFns } from "./checkbox-tree.vue?vue&type=template&id=b855f5d0&"
import script from "./checkbox-tree.vue?vue&type=script&lang=js&"
export * from "./checkbox-tree.vue?vue&type=script&lang=js&"
import style0 from "./checkbox-tree.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports